import api from '@pray/shared/utils/api';

import type { DeleteReportResponse } from './data/response';

type DeleteReportProps = {
  artistId: string;
  reportId: string;
};

export async function deleteReport({ artistId, reportId }: DeleteReportProps): Promise<DeleteReportResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!reportId) throw new Error('Report ID is required');

  const url = `/web/studio/artists/${artistId}/reports/${reportId}`;

  const response = await api.executeDeleteRequest<DeleteReportResponse>(url);
  return response.data;
}
